/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Newsletter_TitleInputs */

const en_blog_resource_newsletter_title = /** @type {(inputs: Blog_Resource_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request the newsletter`)
};

const zh_blog_resource_newsletter_title = /** @type {(inputs: Blog_Resource_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请订阅 Newsletter`)
};

/**
* | output |
* | --- |
* | "Request the newsletter" |
*
* @param {Blog_Resource_Newsletter_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_newsletter_title = /** @type {((inputs?: Blog_Resource_Newsletter_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Newsletter_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_newsletter_title(inputs)
	return zh_blog_resource_newsletter_title(inputs)
});
export { blog_resource_newsletter_title as "blog.resource_newsletter_title" }